import { resolveTableColumnAliases } from './tableColumnAliases.mjs'
import { orderedTableColumns, tableColumnOrder } from './tableColumns.mjs'

export function tableViewConfiguration(state, availableColumns, includeLocation = false, currentLocation = null) {
    const configuration = {
        filters: structuredClone(state.filters ?? {}),
        columns: orderedTableColumns(availableColumns, state.columns, state.columnOrder).map((column) => column.key),
        columnOrder: tableColumnOrder(availableColumns, state.columns, state.columnOrder),
        orderBy: state.orderBy,
        orderByDirection: state.orderByDirection,
    }
    if (includeLocation && currentLocation != null) configuration.location_id = String(currentLocation)
    return configuration
}

export function sameTableView(configuration, state, availableColumns, currentLocation) {
    const normalizeFilters = (filters = {}) => Object.fromEntries(Object.keys(filters).sort().map((key) => [key,
        Array.isArray(filters[key]) ? filters[key].map(String).sort() : String(filters[key])]))
    return JSON.stringify(normalizeFilters(configuration.filters)) === JSON.stringify(normalizeFilters(state.filters))
        && JSON.stringify(orderedTableColumns(availableColumns, configuration.columns, configuration.columnOrder).map((column) => column.key)) === JSON.stringify(orderedTableColumns(availableColumns, state.columns, state.columnOrder).map((column) => column.key))
        && JSON.stringify(tableColumnOrder(availableColumns, configuration.columns, configuration.columnOrder)) === JSON.stringify(tableColumnOrder(availableColumns, state.columns, state.columnOrder))
        && resolveTableColumnAliases([], configuration.orderBy, availableColumns).orderBy === state.orderBy && configuration.orderByDirection === state.orderByDirection
        && (configuration.location_id == null || String(configuration.location_id) === String(currentLocation))
}

export function compareTableViews(a, b) {
    return Number(a.visibility === 'personal') - Number(b.visibility === 'personal')
        || (a.position ?? 0) - (b.position ?? 0)
        || a.id - b.id
}
